export default __webpack_public_path__ + "static/media/package-c.f5f9d5cc.jpg";